// extracted by mini-css-extract-plugin
export default {"container":"ReceivedRelease_container__nsYDG","title":"ReceivedRelease_title__hIoks","message":"ReceivedRelease_message__UUiRk","image":"ReceivedRelease_image__EdA5d"};